export default __webpack_public_path__ + "static/media/Amazon-clone.ace6b49f.jpg";